import React from "react";
import meAvatar from "../../assets/images/me-avatar.png";
import wrigglyArrowUp from "../../assets/icons/wriggly-arrow-up.svg";
import Image from "next/image";
import FooterLinks from "./FooterLinks";
import ContentAnimation from "../shared/ContentAnimation";

const MessageSection = () => {
  return (
    <div className="flex gap-8 md:gap-20 lg:gap-40 3xl:gap-80 relative flex-col md:flex-row px-4 md:px-0">
      <div className="flex items-start gap-4 md:gap-8 flex-col md:flex-row">
        <Image
          src={meAvatar}
          alt="me-avatar"
          width={160}
          height={160}
          className="w-[120px] h-[120px] md:w-[160px] md:h-[160px]"
        />
        <div className="text-white flex flex-col gap-4 md:gap-8 text-lg md:text-2xl font-semibold max-w-[466px]">
          <ContentAnimation delay={0}>
            <p>
              Hey, I am Div, I love creating cool stuff. Let&apos;s be real,
              studying can be a total pain in the ass.{" "}
            </p>
          </ContentAnimation>
          <ContentAnimation delay={0.1}>
            <p>
              SwiftStudy is a platform meant to help you (and me) ace our
              studies without any added{" "}
              <span className="text-primary">bullsh*t.</span>
            </p>
          </ContentAnimation>
          <ContentAnimation delay={0.2}>
            <p>
              SwiftStudy is open source, if you&apos;re down to{" "}
              <span className="text-primary">collaborate</span> or just wanna
              say hi? hit me up!
            </p>
          </ContentAnimation>
          <ContentAnimation delay={0.3}>
            <p>Let&apos;s make studying hella easier!</p>
          </ContentAnimation>
        </div>
      </div>
      <div className="mt-8 md:mt-0">
        <FooterLinks />
      </div>
      <Image
        src={wrigglyArrowUp}
        alt="wriggly-arrow-up"
        width={160}
        height={160}
        className="absolute max-lg:hidden 3xl:hidden top-64 right-12"
      />
    </div>
  );
};

export default MessageSection;
